import { MetalLevel, TierLevel } from '@zorro/clients';
import { getMetalLevelLabel, parseMaybeEnumValue } from '@zorro/common-utils';
import { planTooltipLabels } from '@zorro/types';
import { textToScreamingSnakeCase } from '@zorro/web/ui-utils';

import { MetalLevelMark } from '../../MetalLevelMark';
import { PlanBadge } from '../PlanBadge';

type Props = {
  metalLevel?: MetalLevel | TierLevel | null;
  size?: 'xs' | 'sm' | 'md';
};

export const MetalLevelBadge = ({ metalLevel: level, size = 'sm' }: Props) => {
  const metalLevel = parseMaybeEnumValue(
    MetalLevel,
    textToScreamingSnakeCase(level)
  );
  if (!metalLevel) {
    return null;
  }

  return (
    <PlanBadge
      leftSide={<MetalLevelMark metalLevel={metalLevel} />}
      tooltipLabel={planTooltipLabels.metalLevel}
      label={getMetalLevelLabel(metalLevel)}
      size={size}
    />
  );
};
